import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { Form } from "react-bootstrap";
import "../../assets/css/admin.css";
import DashboardNav from "../../Components/DashboardHeader/DashboardNav";
import { Link, json, useParams } from "react-router-dom";
import Dropdown from "../DashboardComponents/Dropdown/Dropdown";
import DropdownDot from "../DashboardComponents/Dropdown Customer/DropdownDot";
import { AiFillCloseCircle, AiFillCheckCircle } from "react-icons/ai";
import { Spinner } from "react-bootstrap";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { addIron } from "../../Api/iron";
import { getUserById, updateUser, getErrorByField } from "../../Api/auth";
import Modal from 'react-bootstrap/Modal';
import Worang from "../../Components/Icons/Worang";
import Right from "../../Components/Icons/Right";

function FittingDetalis() {

    const soleDesign = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const lieAngle = [
        { value: '1', label: 'Upright', icon: '1' },
        { value: '2', label: 'Standard', icon: '2' },
        { value: '3', label: 'Flat', icon: '3' }
    ];

    const shaftWeight = [
        { value: '1', label: 'Heavy', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Light', icon: '3' }
    ];

    const shaftFlex = [
        { value: '1', label: 'Hard', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Soft', icon: '3' }
    ];

    const shaftProfile = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const gripSize = [
        { value: '1', label: 'Large', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Small', icon: '3' }
    ];

    const shaftLength = [
        { value: '1', label: 'Long', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Short', icon: '3' }
    ];

    const [notes, setNotes] = useState('');

    const handleInitCustomerClub = (name, option) => {
        // console.log("handleInitCustomerClub", name + " === " + option.value);
        setInitCustomerClub(prevState => ({
            ...prevState,
            [name]: option
        }));
    };

    const handleInitCustomerTesting = (name, option) => {
        // console.log("handleInitCustomerTesting", name + " === " + option.value);
        setInitCustomerTesting(prevState => ({
            ...prevState,
            [name]: option
        }));
    };

    const [initCustomerClub, setInitCustomerClub] = useState({
        soledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        lieangle: { value: '0', label: 'Select Angle', icon: '0' },
        shaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        shaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        shaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        gripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        shaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    const [initCustomerTesting, setInitCustomerTesting] = useState({
        testingsoledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        testinglieangle: { value: '0', label: 'Select Angle', icon: '0' },
        testingshaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        testingshaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        testingshaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        testinggripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        testingshaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    const handleAddIron = async (event) => {
        setApicall(true);
        const userData = localStorage.getItem("user");
        const userJson = JSON.parse(userData);
        console.log("user", userJson.user)
        event.preventDefault();
        const data = {
            user_id: params.id, fitter_id: userJson.user._id,
            initCustomerClub: JSON.stringify(initCustomerClub),
            initCustomerTesting: JSON.stringify(initCustomerTesting),
            notes: notes, followupStage: "0", fitting_type: "0"
        };
        setApicall(true);
        addIron(data, event).then((res) => {
            console.log("addIron", res);
            if (res.data.status === true) {
                setErrors([]);
                setApicall(false);
                handleShow();
                setCheckUpdateModel(true)
                window.location.href = "/followups";
            } else {
                alert(res.data.error)
                setErrors(res.data.error);
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    };


    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const params = useParams();

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: ""
    };
    const [formData, setFormData] = useState(initData);

    useEffect(() => {
        if (params.id !== undefined && params.id !== null) {
            getDataById();
        }
    }, [])



    const getDataById = async (e) => {
        getUserById({ _id: params.id }, e).then((res) => {
            console.log("res", res);
            if (res?.code === 200) {
                setFormData(res.data.data);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const handleUpdateSubmit = async (e) => {
        setApicall(true);
        e.preventDefault();
        formData._id = params.id;
        updateUser(formData, e).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            }
            else {
                getDataById()
                setApicall(false);
                handleShow();
            }
        }).catch((err) => {
            alert(err);
        }
        ).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }

    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const [CheckModel, setCheckUpdateModel] = useState(false)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);

    function goBack() { window.history.back() }

    const [pageStage, setPageStage] = useState("view");

    const handleEditView = () => {
        pageStage === "view" ? setPageStage("edit") : setPageStage("view");
    }

    let alertBox = `btn-alert ${initCustomerClub.shaftlength.label !== initCustomerTesting.testingshaftlength.label}`
    let successBox = `btn-success ${initCustomerClub.shaftlength.label === initCustomerTesting.testingshaftlength.label}`
    return (
        <div>
            <Modal
                show={show} // Show the modal when `show` is true
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
                >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">
                        {CheckModel == false && ("User update successfully")}
                        {CheckModel == true && ("Fitting add successfully")}
                        {CheckModel === null && "Stage update successfully"}
                    </h3>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Customer Profile</h3>
                                        </div>
                                        <div className="content-box-btn">
                                            <button className="btn btn-add" onClick={handleEditView}>{pageStage === "view" ? "Edit" : "View"}</button>                                        </div>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                                <fieldset disabled={pageStage === "view" ? true : false}>
                                                    <div className="form-box-section mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Name</label>
                                                                    <input type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="First"
                                                                        value={formData?.firstname}
                                                                        name={"firstname"}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <input type="text"
                                                                        required
                                                                        className={`form-control dashboard-input-box-1 ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                        placeholder="Last"
                                                                        name={"lastname"}
                                                                        value={formData?.lastname}
                                                                        onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                    <Form.Control
                                                                        type="email"
                                                                        className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                        placeholder="Email Address"
                                                                        name="email"
                                                                        required
                                                                        value={formData?.email}
                                                                        onChange={(e) => dataChange(e)} />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {
                                                                            errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                                return item.message;
                                                                            }) : "Please enter valid email"
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Phone</label>
                                                                    <input type="number" name={"phone"} className="form-control dashboard-input-box-3" placeholder="Phone Number" value={formData?.phone} onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Height</label>
                                                                    <div className="d-flex justify-content-end gap-2">
                                                                        <input type="number" className="form-control dashboard-input-box w-30" name={"height_ft"} placeholder="ft." value={formData?.height_ft} onChange={(e) => dataChange(e)} />
                                                                        <input type="number" className="form-control dashboard-input-box w-30" name={"height_in"} placeholder="in." value={formData?.height_in} onChange={(e) => dataChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Wrist to Floor</label>
                                                                    <input type="number" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." value={formData?.wrist_to_floor} onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                                    <input type="number" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." value={formData?.shoulder_to_wrist} onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                                    <input type="number" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." value={formData?.elbow_to_wrist} onChange={(e) => dataChange(e)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        pageStage === "view" ? "" : (
                                                            <div className="sec-btn-group mt-4 update-sec">
                                                                <Link to="/dashboard">
                                                                    <button className="btn btn-cancel">Exit without saving</button>
                                                                </Link>
                                                                {apicall ? (
                                                                    <button className="btn btn-save" disabled><Spinner animation="border" className="border-black" /> </button>
                                                                ) : (
                                                                    <button className="btn btn-save" type="submit">Update Profile</button>
                                                                )}
                                                            </div>
                                                        )
                                                    }
                                                </fieldset>
                                            </Form>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <div className="middle-heading">
                                                    <h3>Customer Club</h3>
                                                </div>
                                            </div>
                                            <Dropdown formlable="Sole Design" options={soleDesign} name={"soledesign"} defaultSelected={initCustomerClub.soledesign} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Lie Angle" options={lieAngle} name={"lieangle"} defaultSelected={initCustomerClub.lieangle} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Weight" options={shaftWeight} name={"shaftweight"} defaultSelected={initCustomerClub.shaftweight} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Flex" options={shaftFlex} name={"shaftflex"} defaultSelected={initCustomerClub.shaftflex} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Profile" options={shaftProfile} name={"shaftprofile"} defaultSelected={initCustomerClub.shaftprofile} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Grip Size" options={gripSize} name={"gripsize"} defaultSelected={initCustomerClub.gripsize} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Length" options={shaftLength} name={"shaftlength"} defaultSelected={initCustomerClub.shaftlength} handleDropDownChange={handleInitCustomerClub} />

                                            <div className="middle-heading">
                                                <h3>Customer Testing</h3>
                                            </div>

                                            <DropdownDot formlable="Sole Design" options={soleDesign} name={"testingsoledesign"} defaultSelected={initCustomerTesting.testingsoledesign} handleDropDownChange={handleInitCustomerTesting} bgcolor="#ffffff" />
                                            <DropdownDot formlable="Lie Angle" options={lieAngle} name={"testinglieangle"} defaultSelected={initCustomerTesting.testinglieangle} handleDropDownChange={handleInitCustomerTesting} bgcolor="#000000" />
                                            <DropdownDot formlable="Shaft Weight" options={shaftWeight} name={"testingshaftweight"} defaultSelected={initCustomerTesting.testingshaftweight} handleDropDownChange={handleInitCustomerTesting} bgcolor="#1841EF" />
                                            <DropdownDot formlable="Shaft Flex" options={shaftFlex} name={"testingshaftflex"} defaultSelected={initCustomerTesting.testingshaftflex} handleDropDownChange={handleInitCustomerTesting} bgcolor="#E050E5" />
                                            <DropdownDot formlable="Shaft Profile" options={shaftProfile} name={"testingshaftprofile"} defaultSelected={initCustomerTesting.testingshaftprofile} handleDropDownChange={handleInitCustomerTesting} bgcolor="#8D25CD" />
                                            <DropdownDot formlable="Grip Size" options={gripSize} name={"testinggripsize"} defaultSelected={initCustomerTesting.testinggripsize} handleDropDownChange={handleInitCustomerTesting} bgcolor="#DA3026" />
                                            <DropdownDot formlable="Shaft Length" options={shaftLength} name={"testingshaftlength"} defaultSelected={initCustomerTesting.testingshaftlength} handleDropDownChange={handleInitCustomerTesting} bgcolor="#D78A31" />

                                            <div className="middle-heading">
                                                <h3>Club Comparison..</h3>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Sole Design
                                                        </div>
                                                        {
                                                            initCustomerClub.soledesign.label === initCustomerTesting.testingsoledesign.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>
                                                    {initCustomerClub.soledesign.label === initCustomerTesting.testingsoledesign.label ? (
                                                        <div className="form-btn-group">
                                                            <div className="btn-susses">{initCustomerClub.soledesign.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingsoledesign.label}</div>
                                                        </div>)
                                                        :
                                                        (<div className="form-btn-group">
                                                            <div className="btn-alert">{initCustomerClub.soledesign.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingsoledesign.label}</div>
                                                        </div>
                                                        )}
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Lie Angle
                                                        </div>
                                                        {
                                                            initCustomerClub.lieangle.label === initCustomerTesting.testinglieangle.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>
                                                    {initCustomerClub.lieangle.label === initCustomerTesting.testinglieangle.label ? (
                                                        <div className="form-btn-group">
                                                            <div className="btn-susses">{initCustomerClub.lieangle.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testinglieangle.label}</div>
                                                        </div>) : (
                                                        <div className="form-btn-group">
                                                            <div className="btn-alert">{initCustomerClub.lieangle.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testinglieangle.label}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Weight
                                                        </div>
                                                        {
                                                            initCustomerClub.shaftweight.label === initCustomerTesting.testingshaftweight.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>
                                                    {initCustomerClub.shaftweight.label === initCustomerTesting.testingshaftweight.label ?
                                                        <div className="form-btn-group">
                                                            <div className="btn-susses">{initCustomerClub.shaftweight.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftweight.label}</div>
                                                        </div> :
                                                        <div className="form-btn-group">
                                                            <div className="btn-alert">{initCustomerClub.shaftweight.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftweight.label}</div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Flex
                                                        </div>
                                                        {
                                                            initCustomerClub.shaftflex.label === initCustomerTesting.testingshaftflex.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>

                                                    {/* <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.shaftflex.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testingshaftflex.label}</div>
                                                    </div> */}

                                                    {initCustomerClub.shaftflex.label === initCustomerTesting.testingshaftflex.label ?
                                                        <div className="form-btn-group">
                                                            <div className="btn-susses">{initCustomerClub.shaftflex.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftflex.label}</div>
                                                        </div> :
                                                        <div className="form-btn-group">
                                                            <div className="btn-alert">{initCustomerClub.shaftflex.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftflex.label}</div>
                                                        </div>}
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Profile
                                                        </div>
                                                        {
                                                            initCustomerClub.shaftprofile.label === initCustomerTesting.testingshaftprofile.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>

                                                    {initCustomerClub.shaftprofile.label === initCustomerTesting.testingshaftprofile.label ? (
                                                        <div className="form-btn-group">
                                                            <div className="btn-susses">{initCustomerClub.shaftprofile.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftprofile.label}</div>
                                                        </div>) : (
                                                        <div className="form-btn-group">
                                                            <div className="btn-alert">{initCustomerClub.shaftprofile.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftprofile.label}</div>
                                                        </div>
                                                    )
                                                    }
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Grip Size
                                                        </div>
                                                        {
                                                            initCustomerClub.gripsize.label === initCustomerTesting.testinggripsize.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>

                                                    {initCustomerClub.gripsize.label === initCustomerTesting.testinggripsize.label ? (
                                                        <div className="form-btn-group">
                                                            <div className="btn-susses">{initCustomerClub.gripsize.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testinggripsize.label}</div>
                                                        </div>) : (
                                                        <div className="form-btn-group">
                                                            <div className="btn-alert">{initCustomerClub.gripsize.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testinggripsize.label}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Length
                                                        </div>
                                                        {
                                                            initCustomerClub.shaftlength.label === initCustomerTesting.testingshaftlength.label ? (
                                                                <Right />
                                                            ) : (
                                                                <Worang />
                                                            )
                                                        }
                                                    </div>

                                                    {initCustomerClub.shaftlength.label === initCustomerTesting.testingshaftlength.label ? (
                                                        <div className="form-btn-group">
                                                            <div className={`btn-susses ${initCustomerClub.shaftlength.label === initCustomerTesting.testingshaftlength.label}`}>{initCustomerClub.shaftlength.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftlength.label}</div>
                                                        </div>) : (

                                                        <div className="form-btn-group">
                                                            <div className={`btn-alert ${initCustomerClub.shaftlength.label === initCustomerTesting.testingshaftlength.label}`}>{initCustomerClub.shaftlength.label}</div>
                                                            <div className="btn-susses">{initCustomerTesting.testingshaftlength.label}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="middle-heading">
                                                <h3>Fitter Notes</h3>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                {/* <textarea
                                                    required
                                                    className='dashboard-text-area'
                                                    id="exampleFormControlTextarea1"
                                                    rows="8" placeholder="Leave your note here..."
                                                    value={notes} onChange={(e) => setNotes(e.target.value)}></textarea> */}


                                                <Form.Control
                                                    type="textarea"
                                                    className={`form-control dashboard-text-area ${getErrorByField(errors, 'notes').length > 0 ? 'is-invalid' : ''}`}
                                                    placeholder="Leave your note here..."
                                                    name="notes"
                                                    required
                                                    style={{ height: '120px' }}
                                                    value={notes}
                                                    onChange={(e) => setNotes(e.target.value)} />
                                                <Form.Control.Feedback type="invalid">
                                                    {
                                                        errors.length > 0 ? getErrorByField(errors, "notes").map((item) => {
                                                            return item.message;
                                                        }) : "Please enter notes"
                                                    }
                                                </Form.Control.Feedback>


                                            </div>
                                        </div>
                                        <div className="sec-btn-group mt-4">
                                            <button className="btn btn-cancel" onClick={goBack}>Exit without saving</button>
                                            {apicall ? (
                                                <button className="btn btn-save" disabled><Spinner animation="border" className="border-black" /> </button>
                                            ) : (
                                                <button onClick={handleAddIron} className="btn btn-save">Save Iron Data</button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FittingDetalis;